export const SITE_ACCESS_STORAGE_KEY = 'animebookmark-site-access-unlocked';
export const SITE_ACCESS_PASSWORD_HASH = '6316409cf68e47c4f001122bbc6e3de60badb23583b1dadd45d73c8f65d59aca';

const SITE_ACCESS_GRANTED_VALUE = '1';

export const isSiteLockEnabled = () => {
    const envValue = `${process.env.VUE_APP_SITE_LOCK_ENABLED || 'true'}`.trim().toLowerCase();
    return envValue !== 'false';
};

export const isSiteUnlocked = () => {
    if (typeof window === 'undefined') {
        return false;
    }
    return window.localStorage.getItem(SITE_ACCESS_STORAGE_KEY) === SITE_ACCESS_GRANTED_VALUE;
};

export const grantSiteAccess = () => {
    if (typeof window === 'undefined') {
        return;
    }
    window.localStorage.setItem(SITE_ACCESS_STORAGE_KEY, SITE_ACCESS_GRANTED_VALUE);
};

const toHex = (buffer) => {
    return Array.from(new Uint8Array(buffer))
        .map((value) => value.toString(16).padStart(2, '0'))
        .join('');
};

export const hashSiteAccessPassword = async (value = '') => {
    if (typeof window === 'undefined' || !window.crypto || !window.crypto.subtle) {
        return '';
    }
    const encoder = new TextEncoder();
    const digest = await window.crypto.subtle.digest('SHA-256', encoder.encode(`${value}`));
    return toHex(digest);
};
